<template>
	<div>
		<!--  blocked dialog box -->
		<v-dialog v-model="is_bloked" width="380"  persistent>
			<v-card>
				<v-card-title
				class="headline flex-column lighten-2"
				primary-title

				>
				<img src="@/assets/blocked.svg" alt="">
			</v-card-title >
			<v-card-text class="flex-column text-center">
				<p class="page-title fs-13 fw-bold">{{$lang.YOUR_ID_IS_BLOCKED}}</p>
				<p class="secondary-text py-2">{{$lang.BLOCKED_MSG}}</p>
			</v-card-text>
		</v-card>
	</v-dialog>
</div>
</template>
<script>
export default{
	props:['is_bloked'],
}

</script>